// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
//
// Ce que le navigateur garde d'un COMPTE (chantier ⑮, décision de Marc du
// 30/09/2026).
//
// ⛔ PLUS AUCUNE DONNÉE MÉTIER DANS `localStorage`. Il appartient au NAVIGATEUR,
// pas au compte, et reste sur le disque : après une déconnexion, et même sous
// un AUTRE compte, la page réaffichait la conversation du précédent, noms de
// fichiers compris (constaté par Marc le 30/09/2026).
//
// Le SERVEUR est la source : historique de NORMA (`analyses.norma_messages`),
// analyses récentes, suivi d'une analyse après fermeture de l'onglet
// (`/api/suivi-analyses`). Le navigateur ne garde, au plus, que l'analyse EN
// COURS DANS CET ONGLET, en `sessionStorage` : elle survit à un rechargement
// (F5), disparaît à la fermeture de l'onglet et n'est jamais vue d'un autre.
//
// Trois gestes, et un seul endroit :
//   - `oublierDonneesDuCompte()` à la déconnexion (et à la suppression du compte) ;
//   - `revendiquerDonnees(userId)` à la connexion : si l'onglet porte les
//     données d'un autre compte (session expirée puis autre connexion), elles
//     sont effacées AVANT tout affichage ;
//   - `nettoyerHeritageLocal()` au démarrage : ce que les versions d'avant le
//     30/09/2026 ont laissé dans `localStorage` (jeton, profil, conversations).

// Préférences de l'APPAREIL, pas du compte : elles restent dans `localStorage`.
const PREFERENCES_APPAREIL = new Set([
  'norma_theme', 'norma_lang',
  'norma_changelog_seen',            // WhatsNewModal : la dernière version lue
  'normascan_annotation_open_tab',   // onglet choisi dans le panneau d'annotation
  // ⚠️ PAS `normascan_annotation_open` : il porte une ANALYSE entière
  // (Analyses.js) — donnée du compte, en `sessionStorage`.
]);

// Tout ce qui appartient au compte : `norma_*`, `normascan_*`, le profil et le
// jeton d'avant le chantier ⑯.
const estDonneeDuCompte = (cle) =>
  !PREFERENCES_APPAREIL.has(cle)
  && (cle.startsWith('norma_') || cle.startsWith('normascan_')
      || cle === 'user' || cle === 'auth_token');

const CLE_PROPRIETAIRE = 'normascan_proprietaire';

const vider = (stockage) => {
  try {
    const cles = [];
    for (let i = 0; i < stockage.length; i++) {
      const cle = stockage.key(i);
      if (cle && estDonneeDuCompte(cle)) cles.push(cle);
    }
    cles.forEach((cle) => stockage.removeItem(cle));
  } catch (_) {
    // Stockage indisponible (navigation privée stricte) : rien à oublier.
  }
};

export function nettoyerHeritageLocal() {
  vider(localStorage);
}

export function oublierDonneesDuCompte() {
  vider(sessionStorage);
  vider(localStorage);
}

export function revendiquerDonnees(userId) {
  if (!userId) return;
  try {
    const proprietaire = sessionStorage.getItem(CLE_PROPRIETAIRE);
    // Sans propriétaire connu, on ne peut pas savoir à qui elles sont : on
    // les efface aussi.
    if (proprietaire !== String(userId)) {
      vider(sessionStorage);
      sessionStorage.setItem(CLE_PROPRIETAIRE, String(userId));
    }
  } catch (_) {
    // idem
  }
}
